// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../root/.nvm/versions/node/v25.9.0/lib/node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.statement-image-container{
  display: flex;
  gap: 24px;
  align-items: center;
  justify-content: space-between;
  padding: 24px;
  flex-wrap: wrap;
}

.statement{
  flex: 1 1 320px;
  min-width: 280px;
}

.image-wrapper{
  flex: 0 0 320px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.responsive-image{
  max-width: 100%;
  height: auto;
  border-radius: 8px;
}

/*  For Hiper links */
.links-container {
  display: flex;
  gap: 12px;
  padding: 2rem;
  flex-wrap: wrap;
  padding: 16px 0; /* keep some vertical padding around the whole block */
  justify-content: center;
  background-color: #f5f5f5;
}

.links-box {
  flex: 1 1;
  min-width: 500;
  max-width: 650px;
   padding: 12px 14px; /* reduce box padding */
  background-color: white;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.links-box h3 {
  color: #050505;
  margin-bottom: 1.5rem;
  font-size: 1.2rem;
  border-bottom: 2px solid #979899;
  padding-bottom: 0.5rem;
}

.links-box ul {
  margin: 0;
  padding-left: 16px; /* keep small indent for bullets */
  list-style-position: inside;
}

.links-box li {
  margin: 0px 0; /* smaller gap between items */
  line-height: 1.35; /* denser lines */

}

.links-box a {
  color: #1d2020;
  text-decoration: none;
  transition: color 0.3s ease;
  padding: 6px 0; /* remove extra vertical padding */
  display: inline-block;
}

.links-box a:hover {
  color: #01070c;
  background-color: #dedcdc;
}

.intro-box {
    background: linear-gradient(to right, #591a7e, #762893);
    color: white;
    padding: 2rem;
    margin: 2rem auto;
    border-radius: 10px;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
    text-align: center;
    max-width: 1500px;
}

.intro-box h1 {
    font-size: 2.5rem;
    margin-bottom: 1rem;
    font-weight: 700;
}

.motto {
    border-top: 2px solid rgba(255, 255, 255, 0.3);
    padding-top: 1rem;
    margin-top: 1rem;
}

.motto p {
    font-size: 1.2rem;
    font-style: italic;
    margin: 0;
}

@media (max-width: 768px) {
    .intro-box {
        margin: 1rem;
        padding: 1.5rem;
    }
    
    .intro-box h1 {
        font-size: 2rem;
    }
    
    .motto p {
        font-size: 1rem;
    }
}

/* Page About Us text Allignment */
.about-text {
  text-align: justify;
  text-justify: inter-word;
}



/*    responsive   web  */
@media (max-width: 768px) {

  /* Stack flex items vertically, reduce padding/margins, smaller fonts */
  .container {
    flex-direction: column;
    padding: 16px;
  }

  h1 {
    font-size: 1.5rem;
  }

  img {
    max-width: 100%;
    height: auto;
  }
}

@media (max-width: 480px) {

  /* Further reductions for phones */
  .nav-bar {
    font-size: 20px;
    padding: 4px 8px;
  }

  .intro-box {
    padding: 1rem;
  }
}


/*    responsive   web  */
.responsive-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 16px;
}

@media (max-width: 768px) {
  .responsive-container {
    padding: 0 8px;
  }
}

`, "",{"version":3,"sources":["webpack://./src/Home.css"],"names":[],"mappings":"AAAA;EACE,aAAa;EACb,SAAS;EACT,mBAAmB;EACnB,8BAA8B;EAC9B,aAAa;EACb,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA,qBAAqB;AACrB;EACE,aAAa;EACb,SAAS;EACT,aAAa;EACb,eAAe;EACf,eAAe,EAAE,sDAAsD;EACvE,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,SAAO;EACP,cAAc;EACd,gBAAgB;GACf,kBAAkB,EAAE,uBAAuB;EAC5C,uBAAuB;EACvB,kBAAkB;EAClB,wCAAwC;AAC1C;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,iBAAiB;EACjB,gCAAgC;EAChC,sBAAsB;AACxB;;AAEA;EACE,SAAS;EACT,kBAAkB,EAAE,kCAAkC;EACtD,2BAA2B;AAC7B;;AAEA;EACE,aAAa,EAAE,8BAA8B;EAC7C,iBAAiB,EAAE,iBAAiB;;AAEtC;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,2BAA2B;EAC3B,cAAc,EAAE,kCAAkC;EAClD,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,yBAAyB;AAC3B;;AAEA;IACI,uDAAuD;IACvD,YAAY;IACZ,aAAa;IACb,iBAAiB;IACjB,mBAAmB;IACnB,wCAAwC;IACxC,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,8CAA8C;IAC9C,iBAAiB;IACjB,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,SAAS;AACb;;AAEA;IACI;QACI,YAAY;QACZ,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;;IAEA;QACI,eAAe;IACnB;AACJ;;AAEA,kCAAkC;AAClC;EACE,mBAAmB;EACnB,wBAAwB;AAC1B;;;;AAIA,yBAAyB;AACzB;;EAEE,uEAAuE;EACvE;IACE,sBAAsB;IACtB,aAAa;EACf;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,eAAe;IACf,YAAY;EACd;AACF;;AAEA;;EAEE,kCAAkC;EAClC;IACE,eAAe;IACf,gBAAgB;EAClB;;EAEA;IACE,aAAa;EACf;AACF;;;AAGA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,cAAc;EACd,eAAe;AACjB;;AAEA;EACE;IACE,cAAc;EAChB;AACF","sourcesContent":[".statement-image-container{\n  display: flex;\n  gap: 24px;\n  align-items: center;\n  justify-content: space-between;\n  padding: 24px;\n  flex-wrap: wrap;\n}\n\n.statement{\n  flex: 1 1 320px;\n  min-width: 280px;\n}\n\n.image-wrapper{\n  flex: 0 0 320px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n}\n\n.responsive-image{\n  max-width: 100%;\n  height: auto;\n  border-radius: 8px;\n}\n\n/*  For Hiper links */\n.links-container {\n  display: flex;\n  gap: 12px;\n  padding: 2rem;\n  flex-wrap: wrap;\n  padding: 16px 0; /* keep some vertical padding around the whole block */\n  justify-content: center;\n  background-color: #f5f5f5;\n}\n\n.links-box {\n  flex: 1;\n  min-width: 500;\n  max-width: 650px;\n   padding: 12px 14px; /* reduce box padding */\n  background-color: white;\n  border-radius: 8px;\n  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);\n}\n\n.links-box h3 {\n  color: #050505;\n  margin-bottom: 1.5rem;\n  font-size: 1.2rem;\n  border-bottom: 2px solid #979899;\n  padding-bottom: 0.5rem;\n}\n\n.links-box ul {\n  margin: 0;\n  padding-left: 16px; /* keep small indent for bullets */\n  list-style-position: inside;\n}\n\n.links-box li {\n  margin: 0px 0; /* smaller gap between items */\n  line-height: 1.35; /* denser lines */\n\n}\n\n.links-box a {\n  color: #1d2020;\n  text-decoration: none;\n  transition: color 0.3s ease;\n  padding: 6px 0; /* remove extra vertical padding */\n  display: inline-block;\n}\n\n.links-box a:hover {\n  color: #01070c;\n  background-color: #dedcdc;\n}\n\n.intro-box {\n    background: linear-gradient(to right, #591a7e, #762893);\n    color: white;\n    padding: 2rem;\n    margin: 2rem auto;\n    border-radius: 10px;\n    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);\n    text-align: center;\n    max-width: 1500px;\n}\n\n.intro-box h1 {\n    font-size: 2.5rem;\n    margin-bottom: 1rem;\n    font-weight: 700;\n}\n\n.motto {\n    border-top: 2px solid rgba(255, 255, 255, 0.3);\n    padding-top: 1rem;\n    margin-top: 1rem;\n}\n\n.motto p {\n    font-size: 1.2rem;\n    font-style: italic;\n    margin: 0;\n}\n\n@media (max-width: 768px) {\n    .intro-box {\n        margin: 1rem;\n        padding: 1.5rem;\n    }\n    \n    .intro-box h1 {\n        font-size: 2rem;\n    }\n    \n    .motto p {\n        font-size: 1rem;\n    }\n}\n\n/* Page About Us text Allignment */\n.about-text {\n  text-align: justify;\n  text-justify: inter-word;\n}\n\n\n\n/*    responsive   web  */\n@media (max-width: 768px) {\n\n  /* Stack flex items vertically, reduce padding/margins, smaller fonts */\n  .container {\n    flex-direction: column;\n    padding: 16px;\n  }\n\n  h1 {\n    font-size: 1.5rem;\n  }\n\n  img {\n    max-width: 100%;\n    height: auto;\n  }\n}\n\n@media (max-width: 480px) {\n\n  /* Further reductions for phones */\n  .nav-bar {\n    font-size: 20px;\n    padding: 4px 8px;\n  }\n\n  .intro-box {\n    padding: 1rem;\n  }\n}\n\n\n/*    responsive   web  */\n.responsive-container {\n  max-width: 1200px;\n  margin: 0 auto;\n  padding: 0 16px;\n}\n\n@media (max-width: 768px) {\n  .responsive-container {\n    padding: 0 8px;\n  }\n}\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
